import {Component, inject} from '@angular/core';
import {
  LoadingPlaceholderComponent
} from "src/app/presentation/common/loading-placeholder/loading-placeholder.component";
import {PaddockStore} from 'src/app/domain/assets/paddocks/paddock.store';
import {Router} from '@angular/router';
import {PaddockSvgComponent} from "src/app/presentation/common/icons/paddock-svg/paddock-svg.component";

@Component({
  selector: 'app-paddocks-button',
  imports: [
    LoadingPlaceholderComponent,
    PaddockSvgComponent
],
  templateUrl: './paddocks-button.component.html',
  styleUrl: './paddocks-button.component.css'
})
export class PaddocksButtonComponent {

  paddockStore = inject(PaddockStore);

  private router = inject(Router);

  open(url: string): void {
    this.router.navigate([url]);
  }
}
